module.exports = __webpack_public_path__ + "static/img/far2.9f3136f5.png";